// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"irisShortcutKeyList_backdrop__2C0Wt","popupPanel":"irisShortcutKeyList_popupPanel__C1k1Y"};